/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CodeListItem } from './CodeListItem';
import {
    CodeListItemFromJSON,
    CodeListItemFromJSONTyped,
    CodeListItemToJSON,
    CodeListItemToJSONTyped,
} from './CodeListItem';

/**
 * A page of codes.
 * @export
 * @interface PaginatedCodesResponse
 */
export interface PaginatedCodesResponse {
    /**
     * The codes on this page
     * @type {Array<CodeListItem>}
     * @memberof PaginatedCodesResponse
     */
    items: Array<CodeListItem>;
    /**
     * Total number of matching codes
     * @type {number}
     * @memberof PaginatedCodesResponse
     */
    total: number;
    /**
     * Number of records skipped
     * @type {number}
     * @memberof PaginatedCodesResponse
     */
    skip: number;
    /**
     * Maximum number of records returned
     * @type {number}
     * @memberof PaginatedCodesResponse
     */
    limit: number;
}

/**
 * Check if a given object implements the PaginatedCodesResponse interface.
 */
export function instanceOfPaginatedCodesResponse(value: object): value is PaginatedCodesResponse {
    if (!('items' in value) || value['items'] === undefined) return false;
    if (!('total' in value) || value['total'] === undefined) return false;
    if (!('skip' in value) || value['skip'] === undefined) return false;
    if (!('limit' in value) || value['limit'] === undefined) return false;
    return true;
}

export function PaginatedCodesResponseFromJSON(json: any): PaginatedCodesResponse {
    return PaginatedCodesResponseFromJSONTyped(json, false);
}

export function PaginatedCodesResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaginatedCodesResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'items': ((json['items'] as Array<any>).map(CodeListItemFromJSON)),
        'total': json['total'],
        'skip': json['skip'],
        'limit': json['limit'],
    };
}

export function PaginatedCodesResponseToJSON(json: any): PaginatedCodesResponse {
    return PaginatedCodesResponseToJSONTyped(json, false);
}

export function PaginatedCodesResponseToJSONTyped(value?: PaginatedCodesResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'items': ((value['items'] as Array<any>).map(CodeListItemToJSON)),
        'total': value['total'],
        'skip': value['skip'],
        'limit': value['limit'],
    };
}

